import Vue from 'vue';
import VModal from 'vue-js-modal'
import VueAWN from 'vue-awesome-notifications';
import Vuelidate from 'vuelidate';
import VueCurrencyInput from 'vue-currency-input';
import VueGtag from "vue-gtag";
import * as amplitude from '@amplitude/analytics-browser';
import 'vue-awesome-notifications/dist/styles/style.css';
import setDefaultOptions from 'date-fns/setDefaultOptions';
import enUS from 'date-fns/locale/en-US';

import App from './App.vue';
import router from './router';
import store from './store';
import formatting from './utils/formatting';
import Column from './components/common/Column';
import Container from './components/common/Container';
import Row from './components/common/Row';
import Banner from './components/common/Banner';
import Button from './components/common/Button';
import ButtonIcon from './components/common/ButtonIcon';
import Icon from './components/common/Icon';
import FormInput from './components/common/FormInput';
import FormInputRange from './components/common/FormInputRange';
import FormNumber from './components/common/FormNumber';
import FormTonsInput from './components/common/FormTonsInput';
import FormCurrency from './components/common/FormCurrency';
import FormSelect from './components/common/FormSelect';
import FormMultiSelect from './components/common/FormMultiSelect';
import FormSearchSelect from './components/common/FormSearchSelect';
import FormSelectClient from './components/common/FormSelectClient';
import FormSelectDriver from './components/common/FormSelectDriver';
import FormSelectWorkOrder from './components/common/FormSelectWorkOrder';
import FormSelectSite from './components/common/FormSelectSite';
import FormSelectState from './components/common/FormSelectState';
import FormSelectStateV2 from './components/common/FormSelectStateV2';
import FormSelectTimeZone from './components/common/FormSelectTimeZone';
import FormSelectVehicle from './components/common/FormSelectVehicle';
import FormTextarea from './components/common/FormTextarea';
import FormToggle from './components/common/FormToggle';
import FormDateInput from './components/common/FormDateInput';
import FormDateTimeInput from './components/common/FormDateTimeInput';
import FormPasswordInput from './components/common/FormPasswordInput';
import FormImageCropUpload from './components/common/FormImageCropUpload';
import syncPropsMixin from './utils/syncPropsMixin';
import analytics from './utils/analytics';

Vue.config.productionTip = false;

Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG },
});
Vue.use(VModal, {
    dynamicDefaults: {
        height: 'auto',
        scrollable: true,
    },
});
Vue.use(Vuelidate);
Vue.use(VueAWN, {
    animationDuration: 200,
    durations: { global: 4000, success: 2000 },
    minDurations: { async: 250 },
});
Vue.use(VueCurrencyInput);

// Initialize Amplitude analytics
analytics.initAmplitude();

Vue.mixin(syncPropsMixin);

Vue.filter('formatCurrency', formatting.formatCurrency);
Vue.filter('formatDateTime', formatting.formatDateTime);
Vue.filter('formatDate', formatting.formatDate);
Vue.filter('formatTime', formatting.formatTime);
Vue.filter('formatDateDistance', formatting.formatDateDistance);
Vue.filter('formatTons', formatting.formatTons);
Vue.filter('humanizeTime', formatting.humanizeTime);

Vue.component('Column', Column);
Vue.component('Container', Container);
Vue.component('Row', Row);
Vue.component('Banner', Banner);
Vue.component('Button', Button);
Vue.component('ButtonIcon', ButtonIcon);
Vue.component('Icon', Icon);
Vue.component('FormInput', FormInput);
Vue.component('FormInputRange', FormInputRange);
Vue.component('FormNumber', FormNumber);
Vue.component('FormCurrency', FormCurrency);
Vue.component('FormSelect', FormSelect);
Vue.component('FormMultiSelect', FormMultiSelect);
Vue.component('FormSelectClient', FormSelectClient);
Vue.component('FormSelectDriver', FormSelectDriver);
Vue.component('FormSelectWorkOrder', FormSelectWorkOrder);
Vue.component('FormSelectSite', FormSelectSite);
Vue.component('FormSelectState', FormSelectState);
Vue.component('FormSelectStateV2', FormSelectStateV2);
Vue.component('FormSelectTimeZone', FormSelectTimeZone);
Vue.component('FormSelectVehicle', FormSelectVehicle);
Vue.component('FormTonsInput', FormTonsInput);
Vue.component('FormTextarea', FormTextarea);
Vue.component('FormToggle', FormToggle);
Vue.component('FormDateInput', FormDateInput);
Vue.component('FormDateTimeInput', FormDateTimeInput);
Vue.component('FormPasswordInput', FormPasswordInput);
Vue.component('FormImageCropUpload', FormImageCropUpload);
Vue.component('FormSearchSelect', FormSearchSelect);

// Register global reference to stripe.
// Note: "Stripe" is globally available and imported from the index.html file.
Vue.prototype.$stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);

// Register global reference to analytics
Vue.prototype.$analytics = analytics;

// Initialize analytics with router for automatic page_key injection
analytics.setRouter(router);

// Set the default locale for date-fns
setDefaultOptions({ locale: enUS });

window.app = new Vue({
    el: '#app',
    router,
    store,
    created() {
        this.$store.dispatch('auth/refreshUser');
    },
    render: h => h(App),
});
